<template>
<div>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
        <div class="wrapper">
            <div class="container-wrapper">
                <div id="alerts-container">
                </div>
            </div>
        </div>

        <!--OFFERS-->
        <div class="row m-t-25">
            <div class="col-xs-12 m-b-10">
                <h3>Ofertas</h3>
            </div>
            <div class="col-xs-12">
                <div class="buy-offer-slide">
                    <template v-for="offer in offers">
                        <div class="col-xs-12 col-lg-4">
                            <div class="offer-container" @click="viewOfferInfo(offer.id)" data-toggle="modal" data-target="#view-offer">
                                <div class="offer-img" :style=" `background: url(${this.mediaUrl}${this.offer.image}) no-repeat center; background-size: cover;`" style="no-repeat center; background-size: cover;"></div>
                                <div class="offer-data p-l-10 p-r-10">
                                    <label class="text-danger">{{ offer.due_date }}<span class="p-l-10 m-l-10 b-l b-grey">-3 días</span></label>
                                    <h4>{{ offer.title }}</h4>
                                    <h4 class="m-t-20">{{ offer.provider }}</h4>
                                    <p class="m-t-15"><i class="md  md-location-on sm-ico"></i>{{ offer.provider_address }}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="clearfix"></div>
            </div>
            <!-- modal view offer -->
            <div class="modal fade" id="view-offer">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="col-xs-12 col-lg-6">
                                <div class="modal-offer-img" :style="`background: url(${this.mediaUrl}${specificOffer.image}) no-repeat center; background-size: cover; no-repeat center; background-size: cover;`"></div>
                            </div>
                            <div class="col-xs-12 col-lg-6">
                                <h3>{{ specificOffer.title }}</h3>
                                <p>{{ specificOffer.description}}</p>
                                <ul class="dots-leader">
                                    <li><span>Descuento</span> <span class="text-20 text-bold">{{ specificOffer.discount_percent }} %</span></li>
                                    <li class="m-t-10"><span>{{ specificOffer.type ? specificOffer.type.name : '' }}</span>
                                        <span v-if="specificOffer.fee =='0'" class="text-20 text-bold">{{ specificOffer.days }} Días</span>
                                        <span v-else class="text-20 text-bold">{{ specificOffer.fee }} Cuotas</span></li>
                                </ul>
                                <div class="clearfix"></div>
                                <hr>
                                <h4>{{specificOffer.provider}}
                                <span class="m-l-10 sm-ico">(<a :href="specificOffer.provider_website" target="_blank">{{specificOffer.provider_website}}</a>)</span>
                            </h4>
                                <p class="m-t-15"><i class="md  md-location-on sm-ico"></i>{{ specificOffer.provider_address }}</p>
                                <p class="m-t-15"><i class="md  md-phone sm-ico"></i>{{ specificOffer.provider_phone }}</p>
                                <div class="text-center m-t-35 m-b-15">
                                    <button class="btn btn-success" @click="orderOffer(specificOffer);">SOLICITAR <i class="b-l b-white p-l-10 m-l-10 md  md-local-offer sm-ico"></i></button>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--/OFFERS-->
            <!-- modal-content -->
            <div class="modal fade" id="_confirmLogoutModal">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Logout</h4>
                        </div>
                        <div class="modal-body">
                            Esta seguro que desea salir del sistema?
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-md-12 pull-right">
                                    <a data-dismiss="modal" class="btn btn-default">VOLVER</a>
                                    <a class="btn btn-primary" id="_submitLogout">LOGOUT</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
        </div>
</template>

<script>
export default {
    data() {
        return {
            offers: [],
            specificOffer: [],
            api: apiUrl,
            mediaUrl: mediaUrl,
        }
    },
    created() {
        this.getAllOffers();
    },
    methods: {
        getAllOffers: function() {
            this.$http.get(apiUrl + '/offers').then(response => {
                this.offers = response.data.data;
                this.$nextTick(() => {
                    this.startSlick('.buy-offer-slide');
                });
            });
        },
        orderOffer: function(offer) {
            console.log(offer);
            let data = new FormData();

            data.append('user_id', userId);
            data.append('offer_id', offer.id);

            this.$http({
                emulateJSON: true,
                emulateHTTP: true,
                url: apiUrl + '/users/' + userId + "/offers/" + offer.id,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data,
            }).then(function(response) {
                swal("Felicidades !", "Oferta solicitada", "success");
                $('#view-offer').modal('toggle');
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido un error solicitando la oferta " + response.status.message, "error");
            });

        },
        viewOfferInfo: function(id) {
            $('#viewOffer').modal('show');

            let fillOffer = this.offers.find(offer => {
                return offer.id == id;
            });

            this.specificOffer = fillOffer;
        },
        startSlick(slickContainer) {
            $(slickContainer).slick({
                lazyLoad: 'ondemand',
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                infinite: false,
                speed: 300,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    },
}
</script>



// WEBPACK FOOTER //
// client-offers-gyms.vue?474d4d2b